import React from "react";
import { Link } from "react-router-dom";
import Ink from "react-ink";
import ItemBadge from "../../Mobile/Items/ItemList/ItemBadge";
import AddToFavorite from "../AddToFavorite/AddToFavorite";
import LazyLoad from "react-lazyload";
import ProgressiveImage from "react-progressive-image";
import { getImageUrl } from '../../../helpers/imageUrl';
import './ItemsGrid.css';

const ItemsGrid = ({
  items,
  category,
  restaurant,
  cartProducts,
  user,
  addProduct,
  removeProduct,
  forceStateUpdate,
  handleAddOnOpen,
  checkRecommended,
  storeColor,
  index,
  categoryLength,
  searching,
  setFavoriteRest,
  recommendedItems,
  isItemRecommended,
  recommendedItemIndex,
  recommendedItemCategory,
  selectedItemId
}) => {
    // 🔥 DISPLAY ALL ITEMS: Show all items passed from parent component
  const maxItems = items || [];
  // console.log(`🔥 ItemsGrid: Processing ${maxItems.length} items`);
  // console.log('🔥 ItemsGrid Items:', maxItems.map(item => item.name));

  // 🔥 DIRECT SIMPLE RENDER: No complex logic, just render the items
  return (
    <div className="grid-item-list">
      {maxItems.map((item, idx) => {
        // console.log(`🔥 ItemsGrid: Rendering item ${idx + 1}/${maxItems.length}: ${item.name}`);
        
        return (
          <div
            key={`grid-${item.id}-${idx}`}
            className="d-flex align-items-center flex-column grid-item"
            style={{ 
              paddingTop: "8px", 
              margin: "1px",
              gridColumn: "span 6" // Each item spans 6 columns out of 12 for 2-column layout
            }}
          >
            <span className="hidden">{(item.quantity = 1)}</span>

            {item.old_price > 0 &&
            localStorage.getItem("showPercentageDiscount") === "true" ? (
              <div className="percentage-ribbon">
                <svg
                  height="41"
                  width="36"
                  viewBox="0 0 29 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M28.9499 0C28.3999 0 27.9361 1.44696 27.9361 2.60412V27.9718L24.5708 25.9718L21.2055 27.9718L17.8402 25.9718L14.4749 27.9718L11.1096 25.9718L7.74436 27.9718L4.37907 25.9718L1.01378 27.9718V2.6037C1.01378 1.44655 0.549931 0 0 0H28.9499Z"
                    fill="#ffa500"
                  />
                </svg>

                <div className="percentage-offer">
                  {parseFloat(
                    ((parseFloat(item.old_price) - parseFloat(item.price)) /
                      parseFloat(item.old_price)) *
                      100
                  ).toFixed(0)}
                  % Off
                </div>
              </div>
            ) : null}
            
            <div className="fav-item">
              <AddToFavorite
                setFavoriteStoreItem={setFavoriteRest}
                isFavourited={item.is_favorited}
                objId={item.id}
                user={user}
                type={"item"}
              />
            </div>

            <Link
              to={{
                pathname: "/stores/" + restaurant.slug + "/" + item.id,
                state: { item },
              }}
              className="anchor-link d-flex align-items-center flex-column"
            >
              <div
                style={{
                  minHeight: "170px",
                  minWidth: "170px",
                  maxHeight: "170px",
                  maxWidth: "170px",
                }}
              >
                <div
                  style={{
                    height: "100%",
                    width: "100%",
                  }}
                >
                  <React.Fragment>
                    {searching ? (
                      <img
                        style={{
                          width: "100%",
                          height: "100%",
                          border: "solid 1px #f2f2f2",
                          borderRadius: "7px",
                        }}
                        src={getImageUrl(item.image)}
                        alt={item.name}
                      />
                    ) : (
                      <LazyLoad>
                        <ProgressiveImage
                          src={getImageUrl(item.image)}
                          placeholder={getImageUrl('/assets/img/various/blank-white.jpeg')}
                        >
                          {(src, loading) => (
                            <img
                              style={{
                                opacity: loading ? "0.5" : "1",
                                width: "100%",
                                height: "100%",
                                border: "solid 1px #f2f2f2",
                                borderRadius: "7px",
                              }}
                              src={src}
                              alt={item.name}
                            />
                          )}
                        </ProgressiveImage>
                      </LazyLoad>
                    )}
                  </React.Fragment>
                </div>
              </div>
              <div className="d-flex align-items-center flex-column width-100">
                <span
                  className="grid-item-name"
                  style={{
                    textAlign: "center",
                    minHeight: "45px",
                  }}
                >
                  {item.brand ? item.brand + " - " : ""}
                  {item.name}
                </span>{" "}
                <span className="width-100 d-flex justify-content-center">
                  <ItemBadge item={item} />
                </span>
              </div>
              <div className="width-100">
                <span>
                  {localStorage.getItem("hidePriceWhenZero") === "true" &&
                  item.price === "0.00" ? null : (
                    <React.Fragment>
                      <div
                        className="d-flex flex-column"
                        style={{ minHeight: "38px" }}
                      >
                        <div className="d-flex justify-content-center">
                          <span className="grid-item-price">
                            {localStorage.getItem("currencySymbolAlign") ===
                              "left" && localStorage.getItem("currencyFormat")}{" "}
                            {item.price}
                            {localStorage.getItem("currencySymbolAlign") ===
                              "right" && localStorage.getItem("currencyFormat")}
                          </span>
                        </div>
                        <div className="d-flex flex-cloumn align-items-center justify-content-center">
                          {item.old_price > 0 && (
                            <span
                              className="strike-text grid-item-price"
                              style={{
                                fontSize: "11px",
                                color: "gray",
                              }}
                            >
                              {" "}
                              {localStorage.getItem("currencySymbolAlign") ===
                                "left" && localStorage.getItem("currencyFormat")}{" "}
                              {item.old_price}
                              {localStorage.getItem("currencySymbolAlign") ===
                                "right" && localStorage.getItem("currencyFormat")}
                            </span>
                          )}
                        </div>
                      </div>
                    </React.Fragment>
                  )}
                </span>
              </div>
              <div className="width-100 d-flex justify-content-center">
                {item.addon_categories && item.addon_categories.length > 0 && (
                  <React.Fragment>
                    <span
                      className="grid-item-customizable"
                      style={{
                        color: storeColor,
                      }}
                    >
                      {localStorage.getItem("customizableItemText")}
                    </span>
                  </React.Fragment>
                )}
              </div>
            </Link>
            
            {/* Add to Cart Button - Moved outside Link */}
            <div
              className="d-flex justify-content-center"
              style={{ width: "100%" }}
            >
              <div
                className="item-actions"
                style={{
                  marginTop: "0",
                  width: "100%",
                }}
              >
                <div
                  className="btn-group btn-group-sm"
                  role="group"
                  aria-label="btnGroupIcons1"
                >
                  {item.is_active ? (
                    <React.Fragment>
                      {!cartProducts.some(
                        (product) => product.id === item.id
                      ) ? (
                        <button
                          className="item-add-btn"
                          type="button"
                          style={{
                            color:
                              item.stock_status === "available"
                                ? "#25a000"
                                : "#a8a8a8",
                          }}
                          onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            if (item.stock_status === "available") {
                              if (item.addon_categories && item.addon_categories.length) {
                                handleAddOnOpen(item);
                              } else {
                                addProduct(item);
                                forceStateUpdate();
                              }
                              // console.log('🔥 ItemsGrid: Add clicked, recommendations DISABLED');
                            }
                          }}
                        >
                          Add
                        </button>
                      ) : (
                        <>
                          {item.addon_categories &&
                          item.addon_categories.length ? (
                            <button
                              disabled
                              type="button"
                              className="btn btn-add-remove"
                              style={{
                                color: localStorage.getItem("cartColor-bg"),
                              }}
                            >
                              <span className="btn-dec">-</span>
                              <Ink duration="500" />
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-add-remove"
                              style={{
                                color: localStorage.getItem("cartColor-bg"),
                                border: "none",
                              }}
                              onClick={(event) => {
                                event.preventDefault();
                                event.stopPropagation();
                                item.quantity = 1;
                                removeProduct(item);
                                forceStateUpdate();
                              }}
                            >
                              <span className="btn-dec">-</span>
                              <Ink duration="500" />
                            </button>
                          )}
                          {cartProducts.find(
                            (cp) => cp.id === item.id
                          ) !== undefined && (
                            <div className="quantity-badge-list">
                              <span>
                                {item.addon_categories && item.addon_categories.length ? (
                                  <React.Fragment>
                                    <i
                                      className="si si-check"
                                      style={{
                                        lineHeight: "1.3rem",
                                      }}
                                    />
                                  </React.Fragment>
                                ) : (
                                  <React.Fragment>
                                    {
                                      cartProducts.find(
                                        (cp) => cp.id === item.id
                                      ).quantity
                                    }
                                  </React.Fragment>
                                )}
                              </span>
                            </div>
                          )}

                          <button
                            type="button"
                            className="btn btn-add-remove"
                            style={{
                              color: localStorage.getItem("cartColor-bg"),
                              border: "none",
                            }}
                            onClick={(event) => {
                              event.preventDefault();
                              event.stopPropagation();
                              if (
                                item.stock >
                                cartProducts.find((cp) => cp.id === item.id)
                                  .quantity
                              ) {
                                if (item.addon_categories && item.addon_categories.length) {
                                  handleAddOnOpen(item);
                                } else {
                                  addProduct(item);
                                  forceStateUpdate();
                                }
                              }
                            }}
                          >
                            <span className="btn-inc">+</span>
                            <Ink duration="500" />
                          </button>
                        </>
                      )}
                    </React.Fragment>
                  ) : (
                    <div
                      className="text-danger text-item-not-available"
                      style={{
                        fontWeight: "600",
                        width: "100%",
                      }}
                    >
                      Out of Stock
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ItemsGrid; 